import { CellProps, VisitCellProps, VisitRequestCellProps } from '@/components/bulkQueue/types';
import { ClinicianChip } from '@/components/clinicians/ClinicianChip';
import { NoneLabel } from '@/components/labels/NoneLabel';
import { HorizontalStack, VerticalStack } from '@/components/utils/linearLayouts';
import { FC } from 'react';

type AppointmentClinicianRowProps = {
    clinician: { id: string; firstName: string; lastName: string; logoUrl: string | null } | null;
};

export const AppointmentClinicianRow: FC<AppointmentClinicianRowProps> = (props) => {
    const { clinician } = props;

    return (
        <HorizontalStack>
            {clinician ? (
                <ClinicianChip clinician={clinician} showLink />
            ) : (
                <NoneLabel text='Unassigned' fontSize='14px' />
            )}
        </HorizontalStack>
    );
};

const ClinicianVisitRequestCell: FC<VisitRequestCellProps> = (props) => {
    const { appointments } = props.entity;

    return (
        <VerticalStack>
            {appointments.length > 0 ? (
                appointments.map((appointment) => (
                    <AppointmentClinicianRow
                        key={appointment.id}
                        clinician={appointment.clinician}
                    />
                ))
            ) : (
                <NoneLabel text='Unassigned' fontSize={'14px'} />
            )}
        </VerticalStack>
    );
};

const ClinicianVisitCell: FC<VisitCellProps> = (props) => {
    const { appointments } = props.entity;

    return (
        <VerticalStack>
            {appointments && appointments.length > 0 ? (
                appointments.map((appointment) => (
                    <AppointmentClinicianRow
                        key={appointment.id}
                        clinician={appointment.clinician}
                    />
                ))
            ) : (
                <NoneLabel text='Unassigned' fontSize={'14px'} />
            )}
        </VerticalStack>
    );
};

export const ClinicianRenderCell: FC<CellProps> = (props) => {
    const { entity } = props;

    switch (entity.__typename) {
        case 'Visit':
            return <ClinicianVisitCell entity={entity} />;
        case 'VisitRequest':
            return <ClinicianVisitRequestCell entity={entity} />;
        default:
            return null;
    }
};
